import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { BillingEventTypeEnum } from '../enums/billing-event-type.enum';
import { BillingMeasuresValues } from '../../../shared/modules/quotation/interfaces/billing-measures-values.interface';

/**
 * Lease billable event DTO
 */
export class LeaseBillableEventDto {
  id!: number;
  tenantId!: number;
  idempotencyKey!: string;
  eventType!: BillingEventTypeEnum;
  sourceSubject!: AppSubjectEnum;
  sourceId!: number;
  sourceUuid!: string;
  sourceReference?: string | null;
  sourceStatus?: string | null;
  measures!: BillingMeasuresValues;
  retryCount!: number;
  meteringProviderCustomerId!: string;
  occurredAt!: string;
}
